export default __webpack_public_path__ + "static/media/BackEnd.2f4f8af0.png";